import { render, staticRenderFns } from "./control-tmpl.vue?vue&type=template&id=1180ebfa&"
import script from "./control-tmpl.vue?vue&type=script&lang=ts&"
export * from "./control-tmpl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports